import styled from 'styled-components';
import { fontSettings } from '../../../styles';

export const TechnicalIssue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const TechnicalIssueTitle = styled.div`
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_22, theme.FONT)};
  color: ${({ theme }): string => theme.COLOR.TEXT_DARK_COLOR};
  font-weight: 500;
  text-align: center;
  margin-bottom: 16px;
`;
export const TechnicalIssueSubtitle = styled.div`
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_17, theme.FONT)};
  color: ${({ theme }): string => theme.COLOR.TEXT_MEDIUM_COLOR};
  text-align: center;
  margin-bottom: 32px;
`;
export const TechnicalIssueImage = styled.div`
  margin-bottom: 16px;
`;
